import BottomSheet from '@perpay-web/components/base/BottomSheet/BottomSheet';
import Card from '@perpay-web/components/base/Card/Card';
import CustomButton from '@perpay-web/components/base/CustomButton/CustomButton';
import potentialCreditLimitOvertime from '@perpay-web/fintech/assets/images/potentialCreditLimitOvertime.svg';
import { useMount } from '@perpay-web/hooks/useMount';
import { getClassName } from '@perpay-web/utils/domUtils';

import styles from './IncreasedDirectDepositDrawer.scss';

const IncreasedDirectDepositDrawer = ({ onClose, onMount, className }) => {
    useMount(onMount);

    return (
        <BottomSheet
            className={getClassName(styles.modal, className)}
            onClose={onClose}
        >
            <div className={styles.header}>Higher Credit Limit</div>
            <div className={styles['copy-container']}>
                <div className={styles.copy}>
                    Credit limits can grow over time. Sending more of your
                    paycheck&apos;s direct deposit can lead to an increased
                    credit limit faster!
                </div>
            </div>
            <Card className={styles['graph-card']}>
                <div className={styles['sub-header']}>
                    Potential Credit Limit Over Time
                </div>
                <img
                    className={styles.graph}
                    src={potentialCreditLimitOvertime}
                    alt='Illustration showing credit limit increase from choosing recommended amount'
                    data-chromatic='ignore'
                />
            </Card>
            <CustomButton
                className={styles['footer-button']}
                Component={CustomButton}
                onClick={onClose}
            >
                Got it!
            </CustomButton>
        </BottomSheet>
    );
};

export default IncreasedDirectDepositDrawer;
